import { render } from "./uiConfirmDialog.vue?vue&type=template&id=4de5f3f1"
import script from "./uiConfirmDialog.vue?vue&type=script&lang=js"
export * from "./uiConfirmDialog.vue?vue&type=script&lang=js"
script.render = render

export default script